import React from 'react';
//import logo from './logo.svg';
import './App.css';
import Routes from './pages/routes';
import { loadReCaptcha } from 'react-recaptcha-v3';
import MetaTags from './MetaTags';

//import dotenv from 'dotenv'

function App() {
	//const dotenv = require('dotenv')
	////console.log(process.env.REACT_APP_TESTE)

	////console.log(process.env.REACT_APP_BASE_URL)s

	const siteKey = process.env.REACT_APP_RECAPTCHA as string;
  loadReCaptcha(siteKey);

	return (
		<div className='App'>
			<MetaTags/>
			<Routes />
		</div>
	);
}

export default App;
